import React from 'react'
import SkillsVisualization from './skills/SkillsVisualization'

export default function Skill() {
    return <SkillsVisualization />
}
